import axios from "axios";
import {CustomerInterface} from "../interfaces/customer/CustomerInterface";
import {CustomerManagerInterface} from "../interfaces/customer/CustomerManagerInterface";

const axiosHttp = axios.create({
    responseType: "json",
    baseURL: process.env.REACT_APP_ENDPOINT,
});

export default function fetchData(url: string, params: any = {}, method: string = 'GET', customer: CustomerInterface|CustomerManagerInterface|null = null) {
    axiosHttp.defaults.headers.common['Authorization'] = customer ? ('Pride ' + customer?.id + '-' + customer?.sign) : false

    switch (method) {
        case 'DELETE':
            return axiosHttp.delete(url).then(response => response.data);
        case 'PUT':
            return axiosHttp.put(url, params).then(response => response.data);
        case 'POST':
            return axiosHttp.post(url, params).then(response => response.data);
        case 'GET':
            return axiosHttp.get(url).then(response => response.data);
        default:
            return axiosHttp.post(url, params).then(response => response.data);
    }
}

export function uploadFile(url: string, formData: FormData, customer: CustomerInterface|CustomerManagerInterface|null = null) {
    axiosHttp.defaults.headers.common['Authorization'] = customer ? ('Pride ' + customer?.id + '-' + customer?.sign) : false

    return axiosHttp.post(url, formData).then(response => response.data);
}